import banner from './banner.vue'
export default banner